import React from 'react';
import { Link } from 'react-router-dom';
import { MenuItems } from './MenuItems';

import './NavBar.css'

const NavBar = () => {

    return (
        <div className='nav-bar'>

            {MenuItems.map((item, index) => {
                return (
                    <span key={index}>
                        <Link className="nav-links" to={item.url} >
                            {item.title}
                        </Link>
                    </span>
                );

            })}
        </div >
    )


}


export default NavBar;